import { PublicConf } from './public-conf.models';

// tslint:disable-next-line:no-var-requires
const pkg = require('../../package.json');

/**
 * Default configuration. Please notice that any property that is not overriden in the specific evironment file, will be taken from here.
 */
export default {
	public: {
		production: false,
		app: {
			name: pkg.name,
			version: pkg.version
		},
		api: {
			baseHref: '/api',
			serverHost: 'http://localhost:4201',
			ignoredRoutes: [
				'^/bo/assets/.*$',
				'^/assets/.*$',
				'^http\:\/\/.*',
				'^https\:\/\/.*'
			]
		},
		security: {
			enabled: true, // Can be used to disable all security checks (login, guards ...)
			url: 'https://keycloak-dev.aon.neo9-solutions.fr/auth', // Url of the identity provider
			realm: 'tmt', // To be set when using keycloak
			clientId: 'urn:aon:client:aqua-tmt-claim-portal-bo', // Client Id of you app
			provider: 'keycloak', // Identity Provider to use, only keycloak available for now
			redirectionPath: '/timers', // Redirect path if the user have not the right role
		}
	} as PublicConf
};
